import { useCallback, useEffect, useState } from "react";
import AnimationContainer from "../../../../Reusable/AnimationContainer/AnimationContainer.js";
import SideBarContentHolder from "../../../../Reusable/SideBar/SideBarContentHolder.js";
import ShareSideComponent from "../../../../Reusable/SideBar/Share/ShareSideComponent.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import { useSideBar } from "../../../../../contexts/sideBarContext/sideBarContext.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../../../contexts/mailContext/mailContext.js";
import { useParams } from "react-router-dom";
import AudioElement from "./components/AudioElement.tsx";
import UploadCompleteHeader from "./components/UploadCompleteHeader.tsx";
import useGalleryAdsContainerStyles from "./hooks/useGalleryAdsContainerStyles.ts";
import useUploadComplete from "./hooks/useUploadComplete.ts";
import UploadCompleteBody from "./components/UploadCompleteBody.tsx";
import apiRequest from "utils/ApiRequest/apiRequest.js";

export const UploadComplete = () => {
  const { getTextByKey, getLanguage } = useContent();
  const { getMailMetaData } = useMail();
  const { setSideBar } = useSideBar();
  const { getBlackFridayTimeCookie } = useContent();
  const { anotherParam } = useParams();
  const { mobileCondition } = useMediaQueries();
  const { showSideBar, handleCloseSidebar } = useUploadComplete();
  const { getMailId } = useMail();

  const [loading, setLoading] = useState(false);
  const [adsData, setAdsData] = useState(null);

  useGalleryAdsContainerStyles(mobileCondition, showSideBar);

  const getGetGalleryPageAds = async () => {
    setLoading(true);
    try {
      const parameters = {
        culture: getLanguage(),
        encryptedMailId: getMailId(),
      };
      const response = await apiRequest(
        "Notifications",
        "GetGalleryPageAds",
        parameters
      );

      setAdsData(response?.data);
    } catch (error) {
      console.error("Error fetching gallery page ads:", error);
      setAdsData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getGetGalleryPageAds();
  }, []);

  const handleShareClick = () => {
    handleCloseSidebar();
    setSideBar(
      <SideBarContentHolder
        headerName={getTextByKey("sidebar-share-header")}
        headerIcon={"share-solid"}
        itemCommentsCount={getMailMetaData().CommentCount}
      >
        <ShareSideComponent email={" "}>{null}</ShareSideComponent>
      </SideBarContentHolder>
    );
  };

  if (anotherParam !== "upload-complete") {
    return false;
  }

  return (
    <AnimationContainer
      animationClassName="side-bar-animation"
      animationOn={showSideBar}
    >
      <div
        className={`upload-complete-sidebar-container${
          getBlackFridayTimeCookie() ? " with-black-friday-header" : ""
        }`}
      >
        <AudioElement />
        <UploadCompleteHeader handleCloseSidebar={handleCloseSidebar} />
        <UploadCompleteBody
          handleShareClick={handleShareClick}
          adsData={adsData}
          loading={loading}
        />
        {/* {conditionShowPickerPromo && <PickerPromo />} */}
      </div>
    </AnimationContainer>
  );
};
